var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"color":"grey lighten-5","app":""}},[_c('v-card-text',{staticClass:"py-2 text-center"},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — Made with ♥ by "),_c('strong',[_vm._v("Sp0m ™")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }